import { render } from "./pieChart2.vue?vue&type=template&id=4f2294f8&scoped=true"
import script from "./pieChart2.vue?vue&type=script&lang=js"
export * from "./pieChart2.vue?vue&type=script&lang=js"

import "./pieChart2.vue?vue&type=style&index=0&id=4f2294f8&scoped=true&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2294f8"]])

export default __exports__